import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a Lineicons Pro icon object (Sprout's illustrative icon set).
 * Same component as documentcollectorfe/src/components/common/SproutIcon.js.
 */
export default function SproutIcon({ icon, color = 'currentColor', size = 24, style, className }) {
  const svg = icon.svg.replaceAll('{color}', color);
  return (
    <svg
      viewBox={icon.viewBox}
      width={size}
      height={size}
      fill={icon.defaultFill || 'none'}
      style={{ flexShrink: 0, ...style }}
      className={className}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}

export const sproutIconShape = PropTypes.shape({
  svg: PropTypes.string.isRequired,
  viewBox: PropTypes.string.isRequired,
  defaultFill: PropTypes.string,
});

SproutIcon.propTypes = {
  icon: sproutIconShape.isRequired,
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  className: PropTypes.string,
};
